/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const MenuSwitchOrganizationIcon: FC<CommonIconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 7.5C10.5 7.08579 10.8358 6.75 11.25 6.75H20.25C20.6642 6.75 21 7.08579 21 7.5C21 7.91421 20.6642 8.25 20.25 8.25H11.25C10.8358 8.25 10.5 7.91421 10.5 7.5Z"
      fill="currentColor"
    />
    <path
      d="M11.25 15.75C10.8358 15.75 10.5 16.0858 10.5 16.5C10.5 16.9142 10.8358 17.25 11.25 17.25H20.25C20.6642 17.25 21 16.9142 21 16.5C21 16.0858 20.6642 15.75 20.25 15.75H11.25Z"
      fill="currentColor"
    />
    <path
      d="M8 7.5C8 8.05228 7.55228 8.5 7 8.5H6.5C5.94772 8.5 5.5 8.05228 5.5 7.5C5.5 6.94772 5.94772 6.5 6.5 6.5H7C7.55228 6.5 8 6.94772 8 7.5Z"
      fill="currentColor"
    />
    <path
      d="M8 16.5C8 17.0523 7.55228 17.5 7 17.5H6.5C5.94772 17.5 5.5 17.0523 5.5 16.5C5.5 15.9477 5.94772 15.5 6.5 15.5H7C7.55228 15.5 8 15.9477 8 16.5Z"
      fill="currentColor"
    />
  </svg>
);
